/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DomainHADto } from '../models/DomainHADto';
import type { DomainHAEditDto } from '../models/DomainHAEditDto';
import type { DomainHAResponseDto } from '../models/DomainHAResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DomainHaControllerService {

    /**
     * @param from
     * @param limit
     * @param name
     * @param phase
     * @returns DomainHAResponseDto OK
     * @throws ApiError
     */
    public static list(
        from?: number,
        limit?: number,
        name?: string,
        phase?: 'COMPLETED' | 'PENDING' | 'RUNNING',
    ): CancelablePromise<DomainHAResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/domainha',
            query: {
                'from': from,
                'limit': limit,
                'name': name,
                'phase': phase,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns DomainHADto OK
     * @throws ApiError
     */
    public static update(
        requestBody: DomainHAEditDto,
    ): CancelablePromise<DomainHADto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/domainha',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns DomainHADto Created
     * @throws ApiError
     */
    public static create(
        requestBody: DomainHADto,
    ): CancelablePromise<DomainHADto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/domainha',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns DomainHADto OK
     * @throws ApiError
     */
    public static get(
        name: string,
    ): CancelablePromise<DomainHADto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/domainha/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns void
     * @throws ApiError
     */
    public static delete(
        name: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/domainha/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
